import { flatpagesApi } from '@features/legal/api/flatpagesApi'
import {
  DEFAULT_LEGAL_SLUG_DATA,
  LEGAL_PAGE_META,
  LEGAL_SLUG_DATA,
} from '@features/legal/constants'
import type { LegalPageKind } from '@features/legal/types'
import { getCountryDomain } from '@shared/lib/getCountryDomain'

/**
 * Загружает legal-страницу и подготавливает региональные meta-данные.
 *
 * @param kind - вид legal-страницы
 * @returns контент, SEO-данные и breadcrumbs страницы
 */
export const useLegalPage = async (kind: LegalPageKind) => {
  const { $host } = useNuxtApp()
  const mode = useRuntimeConfig().public.MODE
  const meta = LEGAL_PAGE_META[kind]

  const countryDomain = getCountryDomain($host, mode)
  const countrySlugData = countryDomain
    ? LEGAL_SLUG_DATA[kind][countryDomain]
    : undefined
  const slugData = countrySlugData ?? DEFAULT_LEGAL_SLUG_DATA[kind]

  const { data: page } = await flatpagesApi.getPage({
    city: slugData.city,
    path: meta.path,
  })

  const breadcrumbs = [
    { text: 'Главная', href: '/' },
    { text: meta.breadcrumbText, href: meta.breadcrumbHref },
  ]

  return {
    title: slugData.title,
    description: slugData.description,
    content: computed(() => page.value?.content ?? ''),
    breadcrumbs,
  }
}
